export default "__VITE_ASSET__uPgyp5Ch__"